import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { matchModeOptions } from './constants'

const MatchModeSelector = ({ value, selectedValues, onChange }) => {
  const { t } = useTranslation()

  const handleChange = e => onChange(e.target.value)

  if (selectedValues.length < 2) return null

  return (
    <div>
      <ComboBox
        fullWidth
        label={t('Coincide cuando')}
        value={value}
        menuItems={matchModeOptions.map(option => ({
          label: t(option.label),
          value: option.value,
        }))}
        handleChange={handleChange}
      />
    </div>
  )
}

export default MatchModeSelector
